import React from 'react';
import '../../styles/enterprise.css';

/**
 * Pill filter tabs with count bubbles. Optional "+ Add filter" ghost pill and a
 * right-aligned slot (e.g. an <EntSearch /> / search input).
 *
 * <FilterTabs
 *   tabs={[{ key: 'all', label: 'All', count: 47 }, ...]}
 *   active="all"
 *   onChange={(key) => setStatus(key)}
 *   onAddFilter={() => ...}        // optional -> renders "+ Add filter"
 *   right={<EntSearch ... />}      // optional right-aligned slot
 *   variant="underline"            // optional: rail of tabs with an underline
 * />
 *
 * The default pill variant is what every existing caller gets. `underline`
 * renders the same tabs as a toolbar rail — used where the tabs sit on the top
 * edge of the table card rather than floating above it.
 */
const FilterTabs = ({ tabs = [], active, onChange, onAddFilter, right, variant = 'pill' }) => (
  <div className={`filter-tabs ${variant === 'underline' ? 'filter-tabs--underline' : ''}`.trim()}>
    {tabs.map((t) => (
      <button
        key={t.key}
        type="button"
        className={`filter-tab ${t.key === active ? 'active' : ''}`.trim()}
        onClick={() => onChange && onChange(t.key)}
      >
        {t.label}
        {t.count !== undefined && t.count !== null ? (
          <span className="filter-tab__count">{t.count}</span>
        ) : null}
      </button>
    ))}
    {onAddFilter ? (
      <button type="button" className="filter-tab filter-tab--ghost" onClick={onAddFilter}>
        + Add filter
      </button>
    ) : null}
    {right ? (
      <>
        <span className="filter-tabs__spacer" />
        {right}
      </>
    ) : null}
  </div>
);

export default FilterTabs;
